<template>
	<div class="rotateDeviceOverlay">
		<div v-if="!hidden" class="iconContainer">
			<div class="phone"><i class="fa fa-repeat"></i></div>
			<p>{{ $t("turnDevice") }}</p>
		</div>
	</div>
</template>

<script>

export default {

  data: function(){
    return{
    	hidden: false,
    }
  },

  mounted(){

  	var self = this
  	setTimeout(function() {
	  	if(!window.noAnimations) {
	  		setInterval(function(){
		  		self.hidden = true
		  		setTimeout(function(){
		  			self.hidden = false

		  		}, 100);

		  	}, 3500);
  		}
  	}, 100);
  }

}
</script>

<style lang="scss">
	.rotateDeviceOverlay {
		display: none;
		position: fixed;
		top: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 1);
		width: 100%;
		height: 100%;
		color: white;
		z-index: 999999;

		.iconContainer {
			width: 200px;
			height: 200px;
			position: absolute;
			left: 50%;
			top: 50%;
			margin-left: -100px;
			margin-top: -100px;
			z-index: 9999;
			& p {
				display: inline-block;
				width: 100%;
				text-align: center;
				margin: 0;
				font-size: 20px;
				opacity: 0;
			}
		}

		.phone {
			position: relative;
			left: 50%;
			margin-left: -50px;
			width: 0;
			height: 0;
			border: 0 solid #000;
			background: #a9a9a9;
			border-radius: 10px;
			box-sizing: border-box;
			& i {
				text-align: center;
				width: 100%;
				line-height: 120px;
				font-size: 50px;
				color: #454545;
				opacity: 0;
			}
		}
	}

	.noAnimations {
		.rotateDeviceOverlay {
			p,
			i {
				opacity: 1 !important;
			}
			.phone {
				left: 65%;
			}
		}
	}

	@media only screen and (max-aspect-ratio: 12/16) and (min-aspect-ratio: 1/16) and (max-width: 650px) and (min-height: 300px) {
		.rotateDeviceOverlay {
			display: block;
		}

		.rotateDeviceOverlay .phone {
			-webkit-animation: sizeIncrease 0.5s forwards ease,
				borderIncrease 0.5s 0.5s forwards ease,
				rotateRight 0.7s 1s forwards ease;
			animation: sizeIncrease 0.5s forwards ease,
				borderIncrease 0.5s 0.5s forwards ease,
				rotateRight 0.7s 1s forwards ease;
		}

		.rotateDeviceOverlay .phone i {
			-webkit-animation: fadeIn 0.5s 0.8s forwards ease;
			animation: fadeIn 0.5s 0.8s forwards ease;
		}

		.rotateDeviceOverlay .iconContainer p {
			-webkit-animation: fadeIn 0.5s 1.3s forwards ease;
			animation: fadeIn 0.5s 1.3s forwards ease;
		}
	}

	/* KEYFRAMES
												------------------------------------------- */
	/* Animate width + height */
	@keyframes sizeIncrease {
		0% {
			width: 0;
			height: 10px;
		}
		50% {
			width: 100px;
			height: 10px;
		}
		100% {
			width: 100px;
			height: 160px;
		}
	}

	@-webkit-keyframes sizeIncrease {
		0% {
			width: 0;
			height: 10px;
		}
		50% {
			width: 100px;
			height: 10px;
		}
		100% {
			width: 100px;
			height: 160px;
		}
	}

	/* Add borders */
	@-webkit-keyframes borderIncrease {
		100% {
			border-width: 20px 10px;
		}
	}
	@keyframes borderIncrease {
		100% {
			border-width: 20px 10px;
		}
	}

	@-webkit-keyframes borderIncrease {
		0% {
			border-width: 0px 0px;
		}
		100% {
			border-width: 20px 10px;
		}
	}

	/* fade-in  */
	@keyframes fadeIn {
		0% {
			opacity: 0;
		}
		100% {
			color: white;
			opacity: 1;
		}
	}

	@-webkit-keyframes fadeIn {
		0% {
			opacity: 0;
		}
		100% {
			color: white;
			opacity: 1;
		}
	}

	/* Rotate device */
	@keyframes rotateRight {
		100% {
			-webkit-transform: rotate(90deg);
			transform: rotate(90deg);
		}
	}

	@-webkit-keyframes rotateRight {
		0% {
			-webkit-transform: rotate(0deg);
			transform: rotate(0deg);
		}
		100% {
			-webkit-transform: rotate(90deg);
			transform: rotate(90deg);
		}
	}
</style>



// WEBPACK FOOTER //
// RotateDevice.vue?199d98c5